import defaultConfig from "./default.mjs";

const config = {
	...defaultConfig,
	urls: {
		pricing: "https://test.egzaminlek.pl/kup-dostep/",
		pricingPes: "https://test.egzaminlek.pl/kup-dostep-pes/",
		landing: "https://test.egzaminlek.pl",
		panel: "https://panel-test.egzaminlek.pl",
	},
	port: 8010,
	API_URL: "https://test.egzaminlek.pl/api/",
	URL_PREFIX: "",
	sentryEnv: "test",
	knowledgeBaseId: 25,
	logOutUrl: "https://test.egzaminlek.pl/logout/",
	NEW_API_URL: "https://api-test.egzaminlek.pl/",
	ADMINS_IDS: [19, 12, 19787],
	CF_AUTH_CLIENT_SECRET:
		"2ad3c0f76cbf724ebba8fd4ef9ebf33f846b9f9bab7a94d3bb50a6a44a5db8f1",
	CF_AUTH_CLIENT_ID: "808c7b9105633b51d9f98604cf613554.access",
	tawkTo: {
		propertyId: "69bd385e7a21c21c339785da",
		widgetId: "1jk5kh9si",
	},
};

export default config;
